// extracted by mini-css-extract-plugin
export default {"priceWrapper":"_5d58ae21","paddle":"_fb13fc67"};